import {NgModule} from "@angular/core";
import {SharedModule} from "../../../shared.module";
import {ProductDrawerComponent} from "./product-drawer.component";

@NgModule({
    imports: [SharedModule],
    declarations: [ProductDrawerComponent],
    exports: [ProductDrawerComponent]
})
export class ProductDrawerModule { }
